import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f340ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logos/Logo_Tuvast.png",
  width: "140"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Wachtwoord wijzigen", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Eisen aan wachtwoord:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" - Minimaal 8 tekens"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Minimaal 1 letter"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Minimaal 1 hoofdletter"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Minimaal 1 cijfer"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Minimaal 1 speciaal teken"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord bevestigen", -1))

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const email = ref<string|null>(null)
const activationKey = ref<string|null>(null)
const password = ref<string|null>(null)
const passwordConfirm = ref<string|null>(null)
const loading = ref<boolean>(false)
const requiredFieldsCompleted = computed(() => {
  return !!(email.value && activationKey.value && password.value && password.value.length >= 8 && (password.value === passwordConfirm.value))
})

onMounted(() => {
  email.value = typeof route.query.email === 'string' ? route.query.email : null
  activationKey.value = typeof route.query.activationKey === 'string' ? route.query.activationKey : null
})

function resetPassword () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/password/activate', {
    email: email.value,
    activationKey: activationKey.value,
    password: password.value
  }).then(() => {
    router.push('/')
    notification.success({
      message: 'Wachtwoord gewijzigd.',
      description: 'Uw wachtwoord is succesvol gewijzigd. U kunt nu inloggen.',
      duration: 5
    })
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 16,
        class: "login-image"
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 8,
        style: {"padding":"64px 16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { style: {"margin-bottom":"64px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_component_a_input, {
                            type: "password",
                            value: password.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createVNode(_component_a_input, {
                            type: "password",
                            value: passwordConfirm.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirm).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "fw-btn",
                            style: {"margin-bottom":"16px"},
                            loading: loading.value,
                            disabled: !_unref(requiredFieldsCompleted),
                            onClick: resetPassword
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Wachtwoord wijzigen")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})